import axios from 'axios'
import React, { Fragment } from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { Row, Button, Col, Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { PostCartaCobro, PostRespuestaCobro } from '../../../store/actions/encargado-cia-action'
import BitacoraGestion from '../../bitacora-gestion-recuperador'
import { useLocation, useNavigate } from 'react-router-dom'
import { CarpetaDigitalComponent } from 'recupero-caso-general'
import Documentos from './Documentos'

const AccionesRespuestaRecobro = ({ formik,porConvenioOld,miRecobroNo }) => {
  const [show, setShow] = useState(false)
  const [showCarpeta, setShowCarpeta] = useState(false)
  const [showBitacora, setShowBitacora] = useState(false)
  const [showModalDocumentos, setShowModalDocumentos] = useState(false)

  const queryState=JSON.parse(localStorage.getItem('filtrosRecuperoCias'));

  const history =useNavigate()
  const [requisitosSelected, setRequisitos] = useState([])
  const data_encargado_cia = useSelector((state) => state.encargado_compania)
  const {requisitosSeleccionados, cfg_form9, llaves} = data_encargado_cia
 
  const handleCloseBitacora = () => {
    setShowBitacora(false)
  }
  const handleShowBitacora = () => setShowBitacora(true)
  const handleShowCarpeta = () => setShowCarpeta(true)
  const handleCloseCarpeta = () => setShowCarpeta(false)
  
  useEffect(() => {
    setRequisitos(requisitosSeleccionados && requisitosSeleccionados)
  }, [requisitosSeleccionados])
  const getResult = function (a1, a2) {
    var i = a1.length
    if (i != a2.length) return false

    while (i--) {
      if (a1[i] !== a2[i]) return false
    }
    return true
  }
  
  const handleShowDocumentos = () => {
    setShowModalDocumentos(true)
  }

  return (
    <>
      <style type='text/css'>
        {`
    .btn-carpeta {
      background-color: #D59B49;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-bitacora {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 140px;
    }
    .btn-bitacora:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    } 
    .btn-carta {
      background-color:  #2E6EA5;
      color: #FFFFFF;
      width: 140px;     
      padding:6px 0px 6px 0px;
    }
    .btn-carta:hover{
        background-color:  #5b9ad1;
        color: #FFFFFF;
    }
    .btn-actualizar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;
      padding:6px 0px 6px 0px;

    }
    .btn-actualizar:hover{
        background-color: #d3807f;
      color: #FFFFFF;
    }
    .btn-volver {
      
      color: #66CCCC;
      border: 1px solid #C00
     
      width: 140px;

    }
   

    .btn-tamano{
      padding: 1rem 1.5rem;
      font-size: 1.5rem;
    }
    `}
      </style>
      <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">      
        
        <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
          idCaso={llaves && llaves['idCaso']}
          idImplicado={llaves && llaves['idImplicado']}
          idOrganizacionCaso={llaves && llaves['idOrgCaso']}
          prototipo={2}            
        />         
    </Modal>
    <Documentos
      llaves={llaves}
      cfg_form={cfg_form9}
      showModalDocumentos={showModalDocumentos}
      setShowModalDocumentos={setShowModalDocumentos}
    />
    <BitacoraGestion
      handleCloseBitacora={handleCloseBitacora}
      showBitacora={showBitacora}
    />
    <Row>
      <Col className='d-flex align-items-end justify-content-end m-2'>
        <Button className='m-2 w-auto' variant='outline-info' onClick={()=> history('/area-trabajo-recupero-companias',{state:{queryState}})}   >
        {cfg_form9 && cfg_form9.cfg_form9["respuestarecobro-btn-volver"]}
        </Button>
        {/*<Button className='m-2 ' variant='carpeta' onClick={handleShowCarpeta}>
        {cfg_form9 && cfg_form9.cfg_form9["respuestarecobro-btn-carpeta"]}
        </Button>*/}
        <Button className='m-2 ' variant='carpeta' onClick={handleShowDocumentos}>
          {cfg_form9 && cfg_form9.cfg_form9["respuestarecobro-btn-documentos"]}
        </Button>
        <Button className='m-2' variant='bitacora'  onClick={handleShowBitacora}>
        {cfg_form9 && cfg_form9.cfg_form9["respuestarecobro-btn-bitacora"]}
        </Button>
        <Button
          className='m-2'
          variant='actualizar'
          type='onSubmit'
          //onSubmit={formik.handleSubmit}
          
          name='procesar'
        >
          {cfg_form9 && cfg_form9.cfg_form9["respuestarecobro-btn-procesarrspta"]}
        </Button>
        
      </Col>
    </Row>
    </>
  )
}

export default AccionesRespuestaRecobro
